<app-breadcrumb [master]="'Administracja'" [parentName]="'Użytkownicy'" [name]="'Blokada logowania'"></app-breadcrumb>
<div class="login-lock-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="login-lock-list-filters">
  </form>

  <div class="login-lock-list-buttons">
    <div class="pull-left" *ngIf="!profile?.loginLock ">
        <button  [disabled]="!(userPermissions | async).user.admin_root" (click)="add()"

                 mat-raised-button class="report-button"><mat-icon>add</mat-icon> Dodaj</button>
    </div>
    <div class="pull-right">
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Rodzaj akcji </th>
      <td mat-cell *matCellDef="let element">
        Blokada logowania
      </td>
    </ng-container>

    <ng-container matColumnDef="startAt">
      <th mat-header-cell *matHeaderCellDef> Data i godzina wykonania </th>
      <td mat-cell *matCellDef="let element">
        {{element.startAt |  date:'y-MM-dd  HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik wykonujący akcję  </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdBy.firstName}} {{element.createdBy.lastName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status akcji </th>
      <td mat-cell *matCellDef="let element">
        {{getStatus(element) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="endAt">
      <th mat-header-cell *matHeaderCellDef> Data i godzina odblokowania </th>
      <td mat-cell *matCellDef="let element">
        {{element.endAt |  date:'y-MM-dd  HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="canStop(element)" mat-raised-button (click)="stop(element.uuid)"> Odblokuj logowanie </button>
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
